import { RootState } from 'store';
import { createSelector } from 'reselect';
import { createCookies } from 'utils/cookies';

export const getAllCookies = createSelector(
  ({ cookie }: RootState) => cookie,
  (cookies) => {
    const cookieWorker = createCookies(cookies);
    return cookieWorker.getAll();
  },
);

export const getIsAuthorized = createSelector(getAllCookies, (cookie) => cookie?.['user-auth'] === 'true');
